import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular'

const routes: Routes = [{
  path: '',
  pathMatch: 'full',
  redirectTo: 'request',
},
{
  path: 'request',
  loadChildren: () => import('./request/request.module').then(m => m.RequestModule),
  canActivate: [MsalGuard]
},
{
  path: 'profile',
  loadChildren: () => import('./profile-overview/profile-overview.module').then(m => m.ProfileOverviewModule),
  canActivate: [MsalGuard]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
